import { Heading1 } from '@cian/ui-kit';
import cn from 'clsx';
import React from 'react';
import { ETestIds } from '../../constants/testIds';
import { useIsDesktop } from '../../hooks/common';
import { ERuntimeSettings } from '../../types/runtimeSettings';
import { useApplicationContext } from '../../utils/applicationContext';
import { QuickLinks } from '../QuickLinksContainer';
import { CalculatorMicrofrontend } from '../microfrontends/CalculatorMicrofrontend';
import { ScrollToOffersButton } from '../stickyButtons/ScrollToOffersButton';
import { useCalculatorHandlers } from './hooks';

import styles from './styles.css';

export interface IControlsContainerProps {
  offersCount: number | null;
  offersIsFetching: boolean;
}

export const ControlsContainer: React.FC<IControlsContainerProps> = ({ offersCount, offersIsFetching }) => {
  const isDesktop = useIsDesktop();
  const { config } = useApplicationContext();
  const mortgageLandingRedesignEnabled = config.get<boolean>(ERuntimeSettings.mortgageLandingRedesign);
  const isSeoCrossLinksEnabled = config.get<boolean>(ERuntimeSettings.isSeoCrossLinksEnabled);
  const isWebView = config.get<boolean>(ERuntimeSettings.isWebView) ?? false;
  const showQuickLinks = isSeoCrossLinksEnabled && !isWebView;
  const { onCatchErrorCalculator, onSubmitCalculator, onSendAnalyticsCalculatorEvent } = useCalculatorHandlers();
  const showScrollToOffersButton = !isDesktop && !mortgageLandingRedesignEnabled;

  const calculator = (
    <CalculatorMicrofrontend
      onSubmitCalculatorEvent={onSubmitCalculator}
      onCatchErrorCalculatorEvent={onCatchErrorCalculator}
      onSendAnalyticsCalculatorEvent={onSendAnalyticsCalculatorEvent}
    />
  );

  if (mortgageLandingRedesignEnabled) {
    return (
      <div className={cn(styles['sidebar'])} data-testid={ETestIds.ControlsContainer}>
        <Heading1 fontWeight="700">Ипотечный калькулятор</Heading1>
        {showQuickLinks ? <QuickLinks variant="sidebar" /> : null}
        {calculator}
      </div>
    );
  }

  return (
    <div data-testid={ETestIds.ControlsContainer}>
      {calculator}
      {showScrollToOffersButton ? (
        <ScrollToOffersButton offersCount={offersCount} isLoading={offersIsFetching} />
      ) : null}
    </div>
  );
};
